import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Typography,
  useMediaQuery
} from '@mui/material';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import { getLastChangeLog, seenLastChangeLog } from './api';
import { useTranslation } from '../../../i18n/LanguageProvider';

const safeJson = (json) => {
  try {
    return JSON.parse(json);
  } catch (e) {
    return json;
  }
};

// eslint-disable-next-line react/prop-types
const ChangeLog = () => {
  const { t } = useTranslation();
  const { data, isSuccess, refetch, isFetching } = useQuery(
    ['change_log'],
    getLastChangeLog
  );
  const seenChangeLogMutation = useMutation({
    mutationFn: seenLastChangeLog,
    onSuccess: () => {
      refetch();
    }
  });

  if (isSuccess && data.data) {
    return (
      <WrapperModal>
        <DialogTitle>
          {t('changeLog.title', { version: data.data.version_num })}
        </DialogTitle>
        <DialogContent>
          <Typography>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  safeJson(data.data.changes_note)?.html ||
                  data.data.changes_note
              }}
            ></div>
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            disabled={seenChangeLogMutation.isLoading || isFetching}
            onClick={() => {
              seenChangeLogMutation.mutate(data?.data?.id);
            }}
          >
            {t('changeLog.gotIt')}
          </Button>
        </DialogActions>
      </WrapperModal>
    );
  }

  return null;
};

// eslint-disable-next-line react/prop-types
const WrapperModal = ({ children }) => {
  const isMobile = useMediaQuery('(max-width: 600px)');

  if (!isMobile) {
    return (
      <Dialog open={true} fullWidth maxWidth={'md'}>
        {children}
      </Dialog>
    );
  }

  return (
    <Drawer open={true} anchor="bottom">
      {children}
    </Drawer>
  );
};

export { ChangeLog };
